export const IMAGES = {
  heroBuilding:
    "https://images.unsplash.com/photo-1775135999914-be730358836c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxnb3Zlcm5tZW50JTIwZmFjaWxpdHklMjBleHRlcmlvciUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MDE1Nzg5Mnww&ixlib=rb-4.1.0&q=85",
  landscaping: "https://images.pexels.com/photos/13630739/pexels-photo-13630739.jpeg",
  hvac: "https://images.pexels.com/photos/37604386/pexels-photo-37604386.jpeg",
  janitorial:
    "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb21tZXJjaWFsJTIwamFuaXRvcmlhbCUyMGZhY2lsaXR5JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzgwMTU3ODk4fDA&ixlib=rb-4.1.0&q=85",
  laundry: "https://images.pexels.com/photos/8774445/pexels-photo-8774445.jpeg",
  furnishings: "https://images.pexels.com/photos/7534170/pexels-photo-7534170.jpeg",
  equipment:
    "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1600&q=80",
  team:
    "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80",
  campus:
    "https://images.unsplash.com/photo-1599687266725-0d4d52d5c3b1?auto=format&fit=crop&w=1600&q=80",
  fieldOps:
    "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1600&q=80",
  govBuilding:
    "https://images.unsplash.com/photo-1564604473722-a32d39cdf68e?auto=format&fit=crop&w=1600&q=80",
  cleanLobby:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
  blueprint:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80",
};

export const CAPABILITIES = [
  {
    id: "facility-support",
    title: "Facility Support Services",
    short: "Janitorial, cleaning support, site readiness, building upkeep, operational support.",
    long: "Comprehensive janitorial, day-porter coverage, site readiness, and recurring upkeep designed for high-traffic government, commercial, and institutional facilities. Disciplined operating procedures, clear quality control, and accountable site supervision keep every building presentation-ready.",
    image: "janitorial",
    naics: "561720",
  },
  {
    id: "grounds-exterior",
    title: "Grounds & Exterior Services",
    short: "Landscaping, grounds maintenance, turf care, irrigation coordination, exterior site appearance.",
    long: "Full-cycle commercial landscaping and grounds maintenance — turf care, seasonal upkeep, hardscape attention, and irrigation coordination — to preserve curb appeal and meet the standards of campuses, cemeteries, municipal grounds, and corporate properties.",
    image: "landscaping",
    naics: "561730",
  },
  {
    id: "mechanical-trade",
    title: "Mechanical & Trade Support",
    short: "Plumbing, heating, air-conditioning, repair coordination, preventive maintenance support.",
    long: "Plumbing, heating, and air-conditioning support coordinated through credentialed trade partners. Preventive maintenance planning, repair response, and documentation built for compliance-sensitive environments.",
    image: "hvac",
    naics: "238220",
  },
  {
    id: "commercial-equipment",
    title: "Commercial Equipment & Operational Solutions",
    short: "Service industry equipment, machinery support, sourcing, logistics, and operational readiness.",
    long: "Sourcing, logistics, and operational deployment for commercial and service industry machinery. From procurement coordination to on-site readiness, we keep operational assets specified, delivered, and accounted for.",
    image: "equipment",
    naics: "333310",
  },
  {
    id: "furnishings-interior",
    title: "Furnishings & Interior Support",
    short: "Furniture sourcing, installation coordination, workspace and institutional furnishing solutions.",
    long: "Commercial and institutional furniture sourcing, installation coordination, and workspace fit-out support. Practical, durable, and procurement-aligned outfitting for offices, public spaces, and institutional environments.",
    image: "furnishings",
    naics: "449110",
  },
  {
    id: "laundry-specialty",
    title: "Textile, Laundry & Specialty Cleaning Support",
    short: "Laundry, drycleaning coordination, linen support, and specialty cleaning services.",
    long: "Commercial laundry, drycleaning coordination, linen rotation, and specialty cleaning programs structured for hospitality, healthcare, and operational environments where consistency and turnaround time matter.",
    image: "laundry",
    naics: "812320",
  },
  {
    id: "custom-contract",
    title: "Custom Contract Support",
    short: "Flexible support for agencies, primes, facilities, and organizations with evolving service needs.",
    long: "Scoped support for agencies, prime contractors, and facility operators with evolving requirements. Street Society can teaming-partner, subcontract, or run discrete scopes of work — adapting to the contract structure, not the other way around.",
    image: "fieldOps",
    naics: "—",
  },
];

export const INDUSTRIES = [
  { title: "Federal Agencies", desc: "Service delivery aligned to federal contracting standards and documentation requirements." },
  { title: "State & Local Government", desc: "Responsive support across state agencies, departments, and local jurisdictions." },
  { title: "Municipal Facilities", desc: "City buildings, public works locations, and community service environments." },
  { title: "Cemeteries & Public Grounds", desc: "Respectful, consistent grounds care for public, veteran, and memorial sites." },
  { title: "Commercial Properties", desc: "Office parks, retail centers, and mixed-use properties requiring dependable upkeep." },
  { title: "Educational Institutions", desc: "K–12 districts, colleges, and university campuses with multi-site needs." },
  { title: "Healthcare & Administrative Facilities", desc: "Compliance-aware support for clinical, administrative, and operational spaces." },
  { title: "Hospitality & Service Environments", desc: "Operations support where presentation, turnaround, and consistency matter." },
  { title: "Industrial & Operational Facilities", desc: "Logistics, warehousing, and operational sites with rigorous service standards." },
];

export const NAICS_CODES = [
  { code: "333310", title: "Commercial and Service Industry Machinery Manufacturing" },
  { code: "561730", title: "Landscaping Services" },
  { code: "238220", title: "Plumbing, Heating, and Air-Conditioning Contractors" },
  { code: "449110", title: "Furniture Retailers" },
  { code: "561720", title: "Janitorial Services" },
  { code: "812320", title: "Drycleaning and Laundry Services" },
];

export const CERTIFICATIONS = [
  "Minority-Owned Business",
  "Small Disadvantaged Business",
  "Women-Owned Small Business",
  "Women-Owned Business",
  "Community Development Corporation Owned",
  "DOT Certified DBE",
];

export const TRUST_ITEMS = [
  { label: "UEI", value: "FGXGDXF8DGT7" },
  { label: "CAGE", value: "8DD93" },
  { label: "Registration", value: "SAM.gov Registered" },
  { label: "Status", value: "Government Contracting Ready" },
];

export const COMPANY = {
  name: "Street Society LLC",
  phone: "(347) 286-9553",
  phoneHref: "tel:+13472869553",
  email: "hello@streetsocietyllc.com",
  emailHref: "mailto:hello@streetsocietyllc.com",
  location: "United States",
  uei: "FGXGDXF8DGT7",
  cage: "8DD93",
};

export const PAST_PROJECTS = [
  {
    title: "Grounds & Exterior Maintenance",
    sector: "Public Grounds",
    detail: "Recurring grounds care and seasonal upkeep for institutional landscapes.",
  },
  {
    title: "Facility Support Services",
    sector: "Commercial Facility",
    detail: "Janitorial coverage and site readiness support across multi-zone buildings.",
  },
  {
    title: "Mechanical / Trade Support",
    sector: "Operational Facility",
    detail: "Coordinated HVAC and plumbing scopes with documented preventive maintenance.",
  },
  {
    title: "Commercial Procurement Support",
    sector: "Institutional Client",
    detail: "Sourcing and operational deployment of service-industry equipment.",
  },
];
